<template>

<control class="text" v-is:icon="hasIcon" :data-theme="theme" v-is:loading="isLoading" v-is:empty="!value">

     <input 
        ref="input" 
        type="text" 
        class="text-input" 
        v-bind:value="value" 
        v-on:input="$emit('input', $event.target.value)" 
        v-on:focus="$emit('focus')" 
        v-on:keydown.enter="onPressEnter"
        :placeholder="placeholder" 
    v-if="!canGrow" />

    <textarea 
        ref="input" 
        class="text-input" 
        v-autogrow 
        v-bind:value="value" 
        v-on:input="$emit('input', $event.target.value)" 
        v-on:keydown.enter="onPressEnter"
        :placeholder="placeholder"
    v-if="canGrow" />

    <icon :n="iconFinal" class="text-icon" v-if="icon" />

</control>

</template>

<script>

export default {

    props: ['value', 'placeholder', 'icon', 'theme', 'canGrow', 'isLoading'],

    computed: {

        iconFinal: function() {

            return (this.isLoading) ? 'loading' : this.icon
            
        },

        hasIcon: function() {

            return this.isLoading || this.icon
            
        }
        
    },

    methods: {

        onPressEnter: function() {

            this.$emit('enter')
            
        }

    }

}

</script>

<style scoped>

.text {
    border: 1px solid #eee;
    border-radius: 10px;
    width: 100%;
}

.text:hover {
    border-color: #999;
}

.text-input {
    height: 38px;
    font-size: 14px;
    width: 100%;
    color: #343434;
    padding: 0px 18px;
}

.text.is-icon .text-input {
    padding-right: 36px;
}

textarea.text-input {
    padding: 10px 18px;
}

.text.is-empty .text-input::placeholder {
    color: #ccc;
}

.text-icon {
    position: absolute;
    right: 35px;
    top: 50%;
    transform: translateY(-50%);
    color: #ccc;
}

</style>
